import { ArrowRightIcon, ArrowLeftIcon } from '@grupoboticario/flora-react-icons';
import Button from './Cta.styles';
import type { CtaProps } from './Cta.d';

const CtaBase = ({ disabled, iconDirection = 'right', onClick }: CtaProps) => (
  <>
    <Button.Wrapper>
      <Button.Cta
        data-testid="cta-cart"
        disabled={disabled}
        onClick={onClick}
        radius="square"
        stretch
      >
        <>
          {iconDirection !== 'right' && <ArrowLeftIcon size={12} />}
          Continuar para pagamento
          {iconDirection === 'right' && <ArrowRightIcon size={12} />}
        </>
      </Button.Cta>
    </Button.Wrapper>
    <Button.Space />
  </>
);

export default CtaBase;
